export const TAX = "Tax";
export const BOOKS = "Books";
export const TAXV2 = "Tax V2";
export const SALES_TAX = "Sales tax";
